import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CustomLoader from "../../../../../Components/CustomLoader";
import ErrorMessage from "../../../../../Components/ErrorMessage";
import EliminarFormaContacto from "./EliminarFormaContacto";
import NuevaFormaContacto from "../Actions/NuevaFormaContacto";
import { useTheme } from "@mui/material";
import { getBicolorTable } from "../../../../../Config/reuserFunctions";

export default function FormasTable({ formasQuery }) {
  const { loading, data, error, refetch } = formasQuery;
  const theme = useTheme();

  if (loading) return <CustomLoader />;
  if (error) return <ErrorMessage />;

  return (
    <Paper variant="outlined" sx={{ overflow: "hidden" }}>
      <TableContainer
        sx={{
          transition: "width .3s",
          height: { xs: `calc(100vh - 190px)`, sm: `calc(100vh - 120px)` },
          overflowX: "scroll",
        }}
      >
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>Forma de contacto</TableCell>
              <TableCell padding="checkbox" />
              <TableCell padding="checkbox" />
            </TableRow>
          </TableHead>
          <TableBody>
            {data.obtenerFormasContacto.map((data, index) => {
              return (
                <TableRow
                  role="checkbox"
                  tabIndex={-1}
                  key={data._id}
                  style={getBicolorTable(theme, index)}
                >
                  <TableCell>{data.formaContacto}</TableCell>
                  <TableCell padding="checkbox">
                    <NuevaFormaContacto
                      edit={true}
                      data={data}
                      refetch={refetch}
                    />
                  </TableCell>
                  <TableCell padding="checkbox">
                    <EliminarFormaContacto data={data} refetch={refetch} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
